/* eslint-disable no-underscore-dangle */
import React, { useRef } from 'react';
import { AbTestCustomAttributes } from '../../../ab-testing/custom-attributes';

import { track } from '../../../analytics/shared';
import { addLoadingState } from '../../../shared/loading-state-helpers';
import { PRODUCTS_DATA_KEY } from '../../../utils/session-storage-keys';
import SessionStorage from '../../../utils/session-storage';

import CouponsHandler from '../../../coupons/handler';

export const FooterContainer = ({ cart, Component }) => {
  const buttonRef = useRef();

  if (cart.item_count === 0) { return null; }

  const handleSubmit = () => {
    if (buttonRef.current) {
      addLoadingState(buttonRef.current);
    }

    const visitToken = sessionStorage.getItem('session_id');
    const isAbTest = AbTestCustomAttributes.get();

    const productsData = cart.items.map((item) => ({
      variantId: item.variant_id,
      quantity: item.quantity,
      subscriptionId: item?.properties?._subscription_id,
      purchase_type: item?.properties?._subscription_id ? 'subscription' : 'one-time',
      visitToken,
      uniqToken: window?.ShopifyAnalytics?.lib?.trekkie?.defaultAttributes?.uniqToken
    }));

    // Add the visit token as a custom cart attribute
    if (visitToken) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            visitToken,
            path: window.location.pathname,
            ...isAbTest && { isAbTest }
          },
          ...isAbTest && { note: 'AB test group' }
        })
      })
        .then((response) => response.json())
        .then(() => {
          // eslint-disable-next-line no-console
          console.log('Cart updated with custom token.');
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.error('Error:', error);
        });
    }

    productsData.forEach((productData) => {
      track({
        eventName: 'checkout_initiated',
        data: {
          line_item_properties: productData
        }
      });
    });

    SessionStorage.set(PRODUCTS_DATA_KEY, productsData);
    SessionStorage.set('uniqToken', window?.ShopifyAnalytics?.lib?.trekkie?.defaultAttributes?.uniqToken);
    SessionStorage.set('visitToken', window?.ShopifyAnalytics?.lib?.trekkie?.defaultAttributes?.visitToken);

    (new CouponsHandler()).removeCouponFromCookies();
  };

  const props = {
    cart,
    buttonRef,
    onSubmit: handleSubmit
  };

  return (
    <Component {...props}/>
  );
};
